import * as React from 'react';
import { Entity, Permiso } from '../utilities/Permisos';
import { Alert, AppBar, Button, ButtonProps, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, IconButton, InputLabel, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent, Slide, Stack, Switch, TextField, Toolbar, Typography } from '@mui/material';
import { GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext, GridCsvExportOptions, GridToolbarContainer, DataGrid, GridRowSelectionModel, GridPaginationModel, GridCallbackDetails, GridRowId } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Common from '../utilities/common';
import $ from "jquery";
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';
import { User } from '../Settings/Users/User';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'permisos' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface IEntityNotificationsProps {
    entity: Entity;
    onOpen?: any;
}

export interface IEntityNotificationsState {
    data: any[];
    open: boolean;
    openNewDialog: boolean;
    openDeleteDialog: boolean;
}

export default class EntityNotifications extends React.Component<IEntityNotificationsProps, IEntityNotificationsState> {
    _notification: any = {};
    _selectedRule: number = -1;

    public constructor(props: IEntityNotificationsProps) {
        super(props);

        this.state = {
            data: [],
            open: false,
            openNewDialog: false,
            openDeleteDialog: false
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <ListItemButton
                    onClick={() => {
                        this.setState(
                            {
                                open: true
                            }
                        );

                        if(this.props.onOpen != null) {
                            this.props.onOpen();
                        }
                    }}
                >
                    <ListItemIcon>
                        <NotificationsNoneOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={'Notificaciones'} />
                </ListItemButton>
                <Dialog open={this.state.open} fullWidth={true} maxWidth={'lg'}>
                    <DialogTitle>
                        <Stack direction={'row'} justifyContent={'space-between'}>
                            <Typography variant='h5'>
                                Notificaciones
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => {
                                    this.setState({
                                        open: false
                                    })
                                }}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant='body2' style={{marginBottom: '40px'}}>
                            Puede crear reglas que indiquen a la aplicación cómo debe gestionar las notificaciones. Deberá elegir tanto las condiciones que activarán una regla en concreto como las acciones que esta deberá realizar.
                        </Typography>
                        {
                            this.state.data.length == 0 && (
                                <Alert severity='info'>
                                    No tiene ninguna regla creada
                                </Alert>
                            )
                        }
                        {
                            this.state.data.length > 0 && this.state.data.map((notification: any, index: number) => {
                                return (
                                    <React.Fragment key={index}>
                                        <Divider/>
                                        <Stack direction={'row'} justifyContent={'space-between'} spacing={3}>
                                            <FormControlLabel control={<Switch defaultChecked={notification.enabled} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                this.Enable(notification.id, event.target.checked);
                                            }}/>} label={`${this.RenderActionCell(notification)} ${this.RenderTypeCell(notification)}`} />
                                            <IconButton onClick={() => {
                                                this._selectedRule = notification.id;
                                                this.setState(
                                                    {
                                                        openDeleteDialog: true
                                                    }
                                                );
                                            }}>
                                                <DeleteOutlineOutlinedIcon />
                                            </IconButton>
                                        </Stack>
                                        <Divider/>
                                    </React.Fragment>
                                )
                            })
                        }
                        {
                            this.state.openNewDialog && (
                                <React.Fragment>
                                    <Typography variant='body2' style={{marginTop: '20px'}} fontSize={'20px'} fontWeight={300}>
                                        Nueva regla
                                    </Typography>
                                    <Divider style={{marginBottom: '20px'}}/>
                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={3}>
                                        <FormControl fullWidth>
                                            <InputLabel id="actionLabel">Desencadenador</InputLabel>
                                            <Select labelId="actionLabel" label="Desencadenador" onChange={(event: SelectChangeEvent) => {
                                                this._notification.action = event.target.value as string;
                                            }}>
                                                {
                                                    this.props.entity != Entity.Consolidaciones && this.props.entity != Entity.Normalizaciones && this.props.entity != Entity.Datos && this.props.entity != Entity.Extracciones && (
                                                        <MenuItem value={'Create'}>Cuando se crea un elemento</MenuItem>
                                                    )
                                                }
                                                {
                                                    this.props.entity != Entity.Consolidaciones && this.props.entity != Entity.Normalizaciones && this.props.entity != Entity.Datos && this.props.entity != Entity.Extracciones && (
                                                        <MenuItem value={'Edit'}>Cuando se modifica un elemento</MenuItem>
                                                    )
                                                }
                                                {
                                                    this.props.entity != Entity.Consolidaciones && this.props.entity != Entity.Normalizaciones && this.props.entity != Entity.Datos && this.props.entity != Entity.Extracciones && (
                                                        <MenuItem value={'Delete'}>Cuando se elimina un elemento</MenuItem>
                                                    )
                                                }
                                                {
                                                    (this.props.entity == Entity.Consolidaciones || this.props.entity == Entity.Normalizaciones || this.props.entity == Entity.Datos || this.props.entity == Entity.Extracciones) && (
                                                        <MenuItem value={'En proceso'}>
                                                            Cuando se inicie el proceso de 
                                                            {
                                                                this.props.entity == Entity.Consolidaciones && (
                                                                    ' consolidación'
                                                                )
                                                            }
                                                            {
                                                                this.props.entity == Entity.Normalizaciones && (
                                                                    ' normalización'
                                                                )
                                                            }
                                                            {
                                                                this.props.entity == Entity.Extracciones && (
                                                                    ' extracción'
                                                                )
                                                            }
                                                        </MenuItem>
                                                    )
                                                }
                                                {
                                                    (this.props.entity == Entity.Consolidaciones || this.props.entity == Entity.Normalizaciones || this.props.entity == Entity.Datos || this.props.entity == Entity.Extracciones) && (

                                                        <MenuItem value={'Finalizado'}>
                                                            Cuando finalice el proceso de
                                                            {
                                                            this.props.entity == Entity.Consolidaciones && (
                                                                ' consolidación'
                                                            )
                                                            }
                                                            {
                                                                this.props.entity == Entity.Normalizaciones && (
                                                                    ' normalización'
                                                                )
                                                            }
                                                            {
                                                                this.props.entity == Entity.Extracciones && (
                                                                    ' extracción'
                                                                )
                                                            }
                                                        </MenuItem>
                                                    )
                                                }
                                                {
                                                    (this.props.entity == Entity.Consolidaciones || this.props.entity == Entity.Normalizaciones || this.props.entity == Entity.Datos || this.props.entity == Entity.Extracciones) && (
                                                        <MenuItem value={'Error'}>
                                                            Cuando ocurra un error durante el proceso de
                                                            {
                                                            this.props.entity == Entity.Consolidaciones && (
                                                                ' consolidación'
                                                            )
                                                            }
                                                            {
                                                                this.props.entity == Entity.Normalizaciones && (
                                                                    ' normalización'
                                                                )
                                                            }
                                                            {
                                                                this.props.entity == Entity.Extracciones && (
                                                                    ' extracción'
                                                                )
                                                            }
                                                        </MenuItem>
                                                    )
                                                }
                                            </Select>
                                        </FormControl>
                                        <FormControl fullWidth>
                                            <InputLabel id="typeLabel">Acción</InputLabel>
                                            <Select labelId="typeLabel" label="Acción" onChange={(event: SelectChangeEvent) => {
                                                this._notification.type = event.target.value as string;
                                            }}>
                                                <MenuItem value={'App'}>Mostrarme una notificación en la aplicación</MenuItem>
                                                <MenuItem value={'Email'}>
                                                {
                                                    `Enviarme un correo electrónico a la siguiente dirección: ${Common.GetUserProp('username')}`
                                                }
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                </React.Fragment>
                            )
                        }
                    </DialogContent>
                    <DialogActions>
                        {
                            !this.state.openNewDialog && (
                                <Button variant='contained' onClick={() => {
                                    this.setState({
                                        openNewDialog: true
                                    })
                                }}>Crear nueva regla</Button>
                            )
                        }
                        {
                            this.state.openNewDialog && (
                                <Button variant='contained' onClick={this.Save.bind(this)}>Guardar</Button>
                            )
                        }
                        {
                            this.state.openNewDialog && (
                                <Button variant='contained' onClick={() => {
                                    this.setState({
                                        openNewDialog: false
                                    })
                                }}>Cancelar</Button>
                            )
                        }
                        <Button variant='contained' onClick={() => {
                            this.setState({
                                open: false,
                                openNewDialog: false
                            })
                        }}>Cerrar</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.openDeleteDialog} fullWidth>
                    <DialogTitle>
                        Eliminar regla
                    </DialogTitle>
                    <DialogContent>
                        Si elimina esta regla dejará de recibir notificaciones. ¿Desea eliminar la regla seleccionada?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Delete.bind(this)}>OK</Button>
                        <Button onClick={() => {
                            this.setState(
                                {
                                    openDeleteDialog: false
                                }
                            )
                        }}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }

    private Get(): void {
        let url = `${Common.END_POINT}/notificaciones/user/${this.props.entity}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('NotificaitonsUser', response);
            this.setState(
                {
                    data: response,
                    openNewDialog: false,
                    openDeleteDialog: false
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        });
    }

    private Enable(id: number, enable: boolean): void {
        let url = `${Common.END_POINT}/notificaciones/${id}/enable/${enable}`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.Get();
        });
    }

    private Save(): void {
        this._notification.entityId = this.props.entity;

        console.log(this._notification);

        let url = `${Common.END_POINT}/notificaciones`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._notification),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.Get();
        });
    }

    private Delete(): void {
        let url = `${Common.END_POINT}/notificaciones/delete/${this._selectedRule}`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.Get();
        });
    }

    private RenderActionCell(row: any): string {
        let text: string = '';

        switch(row['action']) {
            case 'Create': 
                text = "Cuando se crea un elemento";
                break;
            case 'Edit': 
                text = "Cuando se modifique un elemento";
                break;
            case 'Delete': 
                text = "Cuando se elimine un elemento";
                break;
        }
        
        return text;
    }

    private RenderTypeCell(row: any): string {
        let text: string = '';

        switch(row['type']) {
            case 'App': 
                text = "mostrarme una notificación en la aplicación";
                break;
            case 'Email': 
                text = `enviarme un correo electrónico a la siguiente dirección: ${Common.GetUserProp('username')}`;
                break;
        }
        
        return text;
    }
}